import React, { FormEvent, useState, useEffect } from 'react'
import { useForm } from '../hooks/form/useForm'
import { Tranzilla } from './Tranzilla'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import KeepAlive, { AliveScope } from 'react-activation'
import { useGetAccount } from '../hooks/useGetAccount'
import { CSSTransition } from 'react-transition-group'
const { Checkbox, Button, Loader } = require('monday-ui-react-core')
const { Check, CloseSmall } = require('monday-ui-react-core/icons')


interface PurchaseProps {
  mondayAccountId: number
  accessToken: string
  setMondayError: React.Dispatch<React.SetStateAction<boolean>>
}

export const Purchase: React.FC<PurchaseProps> = ({ mondayAccountId, accessToken, setMondayError }) => {
  const [account, setAccount] = useState<Account>()
  const [chosenPlan, setChosenPlan] = useState<PlanCard | null>(null)
  const [isValidEmail, setIsValidEmail] = useState<any>()
  const [currPlan, setCurrPlan] = useState<PlanCard | undefined>()
  const [credentials, handleChange, setCredentials] = useForm({
    contact: '',
    billEmail: '',
    company: '',
    phoneNumber: '',
    isLocal: false,
  })
  const [openTranzilla, setOpenTranzilla] = useState<boolean>(false)

  // Getting the account from here and not from Home because when purchasing it is not updating immediatly, you need to refresh first.
  // by this way it is updating directly. todo: think on better solution
  useGetAccount(mondayAccountId, setAccount, accessToken, setMondayError)

  const handleSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault()

    setOpenTranzilla(true)
  }

  const checkEmail = (email: string) => {
    email = email.toLowerCase()
    const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
    setIsValidEmail(emailRegex.test(email))
  }

  useEffect(() => {
    credentials.billEmail && checkEmail(credentials.billEmail)
  }, [credentials.billEmail])

  const plansCards: PlanCard[] = [
    {
      name: 'Free',
      price: 0.0,
      features: ['10 Tickets per month', 'No support available'],
      billType: 'Free',
    },
    {
      name: 'Pro',
      price: 16,
      features: ['100 Tickets per month', 'Standard Support (2-day SLA via Email)'],
      billType: 'Billed annually ($192)',
    },
    {
      name: 'Business',
      price: 28,
      features: ['500 Tickets per month', 'Standard Support (2-day SLA via Email)'],
      billType: 'Billed annually ($336)',
    },
    {
      name: 'Enterprise',
      price: 42,
      features: ['Unlimited Tickets', 'Enterprise support  (1-day SLA via Email & Phone)'],
      billType: 'Billed annually ($504)',
    },
  ]

  useEffect(() => {
    if(account) {
      const currPlan: PlanCard | undefined = plansCards.find((card) => card.name.toLocaleLowerCase() === account?.license)
      setCurrPlan(currPlan)
    } 
  }, [account])
  

  const handleIsLocal = () => {
    setCredentials((prevCred: any) => ({
      ...prevCred,
      isLocal: !prevCred.isLocal,
    }))
  }

  if (!account)
    return (
      <div className="loading">
        <Loader hasBackground />
      </div>
    )
  else if (openTranzilla) return <Tranzilla chosenPlan={chosenPlan!} credentials={credentials} mondayAccountId={account.mondayAccountId} />
  return (
    <AliveScope>
      <section className="purchase-container">
        <CSSTransition in={!!chosenPlan} timeout={300} classNames="form-transition">
          {!chosenPlan ? (
            <>
              <h2>Choose a plan that's right for you</h2>
              <ul className="pricing">
                {plansCards.map((card, idx) => (
                  <li key={card.name} className="plan-card">
                    <div className="card-header">
                      <h3>{card.name}</h3>
                    </div>
                    <div className="card-price">
                      <h4>
                        ${card.price} <span>/ mo</span>
                      </h4>
                      <h5>{card.billType}</h5>
                    </div>
                    <div className='card-features'>

                    {card.features.map((feature) => (
                      <div className="feature" key={feature}> <span style={card.name === 'Free' ? {color: 'red'}: {color: 'green'}}>{card.name === 'Free' ? <CloseSmall /> : <Check/> }</span><p >{feature}</p></div>
                      ))}
                      </div>
                    {plansCards.findIndex((card) => card.name.toLocaleLowerCase() === account.license) <= idx && (
                      <Button disabled={true} onClick={() => setChosenPlan(card)}>
                        {account.license === card.name.toLocaleLowerCase() ? 'Current Plan' : 'Choose'}
                      </Button>
                    )}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <KeepAlive>
              <form>
                <span onClick={() => setChosenPlan(null)} className="arrow-back">
                  <FontAwesomeIcon icon={faArrowLeft} />
                </span>
                <h3>
                  {chosenPlan.name} plan <span>{`(Total: ${chosenPlan.price * 12}$ 1Year)`}</span>
                </h3>
                <hr />
                <label>
                  Bill to:
                  <input type="name" placeholder="Enter contact name" name="contact" onChange={handleChange} value={credentials.contact} />
                </label>
                <label>
                  Send invoice to:
                  <input type="email" name="billEmail" placeholder="Email address for invoice" onChange={handleChange} value={credentials.billEmail} />
                </label>
                <label>
                  Company name:
                  <input type="name" name="company" placeholder="Enter company name" onChange={handleChange} value={credentials.company} />
                </label>
                <label>
                  Phone number:
                  <input type="tel" name="phoneNumber" placeholder="Enter contact phone number" onChange={handleChange} value={credentials.phoneNumber} />
                </label>
                <label>
                  Are you from israel?
                  <Checkbox checked={credentials.isLocal} onChange={handleIsLocal} />
                  <div className="tooltip">
                    <span>
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </span>
                    <div className="tooltip-container">{'Same price with VAT included'}</div>
                  </div>
                </label>
                <Button disabled={true} onClick={(event: FormEvent) => handleSubmit(event)}>
                  Checkout now
                </Button>
              </form>
              <p className="eula">
                With accordance to our EULA:{' '}
                <a href="https://eswlab.com/products/monday/esls-apps/freshservice-integration/eula/" target="_blank" rel="noreferrer">
                  ESL’s FreshService for monday.com – EULA | ESL (eswlab.com)
                </a>
              </p>
            </KeepAlive>
          )}
        </CSSTransition>
      </section>
    </AliveScope>
  )
}
